import Vue from 'vue'

const state = () => ({
  paymentHistory: null,
  availableProducts: null,
  products: null
})

const getters = {}

const actions = {
  async getPaymentHistory ({ commit }) {
    const result = await Vue.$http.get('/Subscriptions/GetPaymentHistory')
    if (result?.status === 200) {
      commit('SET_DATA', ['paymentHistory', result?.data.$values])
      return true
    }
  },
  async getAvailableProducts ({ commit }) {
    const result = await Vue.$http.get('/Subscriptions/GetAvailableProducts')
    if (result?.status === 200) {
      commit('SET_DATA', ['availableProducts', result?.data.$values])
      return true
    }
  },
  async getProducts ({ commit }) {
    const result = await Vue.$http.get('/Subscriptions/products')
    if (result?.status === 200) {
      commit('SET_DATA', ['products', result?.data.$values])
      return true
    }
  }
}

const mutations = {
  SET_DATA: (state, payload) => {
    const [property, value] = payload
    Vue.set(state, property, value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
